var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("Server Side Rendering")]),(_vm.builderData)?_c('Builder',{ref:"builder",attrs:{"user-mode":false,"builderData":_vm.builderData,"hideGuides":true},on:{"ready":_vm.downloadHQ}}):_vm._e(),(_vm.pages)?_c('Merger',{attrs:{"pages":_vm.pages}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }